import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { NavLink, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import Header from '../Headers/Header';
import MapView from '../../components/MapView/MapView';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import CircularProgress from '@material-ui/core/CircularProgress';
import { setCookie, clearCookie, getUserDetails } from '../../functions/Auth';
import Cookies from 'js-cookie';
import API_PATH from "../../constants/config.json";

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Css code start ....
const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '98%',
        },
    },
    rootBox: {
        flexGrow: 1,
    },
    paper: {
        width: '100%',
        boxShadow: 'none',
        display: 'flex'
    },
    signMain: {
        position: 'fixed',
        width: '100%',
        background: 'rgba(0,0,0,.5)',
        height: '100vh',
        top: '0',
        zIndex: '999'
    },
    signInBtn: {
        border: '1px solid rgba(36, 97, 142, 1)',
        color: '#fff',
        background: 'rgba(36, 97, 142, 1)!important',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '14px',
            width: '185px',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
            width: '275px',
            marginBottom: '10px',
        },
    },
    formLogo: {
        textAlign: 'center',
        width: '100%',
        paddingTop: '15px',
        '& p': {
            textAlign: 'right',
            margin: '0px 0 -20px',
            paddingRight: '15px',
            fontSize: '25px',
        },
        '& a': {
            color: '#24618E',
        }
    },
    rootForm: {
        margin: '10px auto 25px',
        border: '1px solid rgba(0, 167, 93, 1)',
        padding: '10px',
        borderRadius: '5px',
        boxShadow: '1px 4px 5px 1px #ccc',
        '@media only screen and (max-width: 3500px)': {
            width: '80%',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '85%',
        },
        '& h3': {
            color: '#24618E',
            marginTop: '0px',
            marginBottom: '0',
            '@media only screen and (max-width: 3500px)': {
                fontSize: '20px',
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '26pt',
            },
        },
        '& input#confirm_new_password': {
            padding: '10px',
        },
        '& input#new_password': {
            padding: '10px',
        },
    },
    formInput: {
        width: '100%',
    },
    OtherLink: {
        width: '80%',
        margin: '0 auto',
        '& a': {
            color: '#24618E',
        }
    },
    errIcon: {
        fontSize: '26px',
        color: '#CC0000',
        margin: '2%'
    },
    errorInput: {
        width: '100%',
        backgroundColor: '#F2DEDE',
        border: '1px solid #CC0000'
    },
    errMsgForgot: {
        '& span': {
            fontSize: '11pt !important'
        }
    },
    signInBtn: {
        border: '1px solid rgba(36, 97, 142, 1)',
        color: '#fff',
        background: 'rgba(36, 97, 142, 1)!important',
        fontFamily: 'Avenir Light',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '14px',
            width: '185px',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
            width: '200px',
            marginBottom: '10px',
        },
        '& .MuiCircularProgress-root': {
            color: '#fff',
            '@media only screen and (max-width: 3500px)': {
                width: '25px !important',
                height: '25px !important',
            },
            '@media only screen and (min-width: 3501px)': {
                width: '45px !important',
                height: '45px !important',
            },
        }
    },
    cancelBtn: {
        border: '1px solid #333',
        color: '#333',
        background: '#fff!important',
        fontSize: '12px',
        width: '140px',
    },
    userFormContainer: {
        '@media only screen and (max-width: 3500px)': {
            width: '500px',
            paddingTop: '90px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '650px',
            maxWidth: '650px',
            paddingTop: '250px',
            '& input': {
                fontSize: '22pt',
            }
        },
    },
    closeIcon: {
        '&:hover': {
            color: '#CC0000',
        }
    },
    formIcon: {
        '@media only screen and (max-width: 3500px)': {
            width: '215px',
            height: '50px'
        },
        '@media only screen and (min-width: 3501px)': {
            width: '300px',
            height: '70px'
        },
    }
}));
//Css code end ....

//Start ChangeAdminPassword component code ....
const ChangeAdminPassword = () => {
    let history = useHistory();
    const [spacing, setSpacing] = React.useState(2);
    const [errMsg, setErrMsg] = React.useState(null);
    const [errPassword, setErrPassword] = React.useState(null);
    const [errMsgType, setErrMsgType] = React.useState('error');
    const [errPopUp, setErrPopUp] = React.useState(false);
    const [loader, setLoader] = React.useState(false);
    const [values, setValues] = React.useState({
        newPass: "",
        conNewPass: ""
    });
    const classes = useStyles();

    const handleChange = name => event => {
        setValues({ ...values, [name]: event.target.value });
    }

    //This code is use for form validations ... start
    const validateForm = async e => {
        setErrMsg(null)
        e.preventDefault()
        if (values.newPass === '' ||
            values.conNewPass === '') {
            setErrPassword(true);
            setErrMsg('All fields are required');
            setErrPopUp(true)
        }
        else {
            if (values.newPass === values.conNewPass) {
                setLoader(true);
                getUserLogin();
            }
            else {
                setErrPassword(true);
                setErrMsg('New Password & Confirm New Password are Not Same !');
                setErrPopUp(true)
            }
        }
    }
    //This code is use for form validations ... end

    //This code is use for update temporary password ... start
    const getUserLogin = async () => {
        try {
            axios({
                method: 'post',
                data: {
                    email: Cookies.get('email'),
                    pwd: values.newPass,
                    session: Cookies.get('session')
                },
                url: API_URL + API_PATH.updateTemporaryPasswordAPI,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        await setCookie('idToken', response.data.message.data.AuthenticationResult.IdToken);
                        await setCookie('payload', response.data.message.payload);
                        await setCookie('atexpiry', response.data.message.data.AuthenticationResult.access_token_expiry);
                        await refreshToken();
                    }
                    else {
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                        setLoader(false);
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        setErrMsgType('error')
                        setErrMsg(error.response.data.message.message);
                        setErrPopUp(true)
                        setLoader(false);
                    } else {
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                        setLoader(false);
                    }
                })
        } catch (error) {
            console.error(error);
            setLoader(false);
        }
    }
    //This code is use for update temporary password ... end

    //This code is use for get scrftoken ... start
    const refreshToken = () => {
        try {
            axios({
                method: 'get',
                url: API_URL + API_PATH.getcsrftoken,
            })
                .then(async function (response) {
                    if (response && response.data && response.data.csrfToken) {
                        axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrfToken;
                        await getProfile(response.data.csrfToken);
                    } else {
                        if (Cookies.get('email')) {
                            clearCookie('email');
                            clearCookie('payload');
                            clearCookie('idToken');
                            clearCookie('atexpiry');
                        }
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                    }
                    setLoader(false);
                })
                .catch(function (error) {
                    if (Cookies.get('email')) {
                        clearCookie('email');
                        clearCookie('payload');
                        clearCookie('idToken');
                        clearCookie('atexpiry');
                    }
                    setErrMsgType('error')
                    setErrMsg('Something went wrong.');
                    setErrPopUp(true)
                    setLoader(false);
                })
        } catch (error) {
            if (Cookies.get('email')) {
                clearCookie('email');
                clearCookie('payload');
                clearCookie('idToken');
                clearCookie('atexpiry');
            }
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
            setLoader(false);
        }
    }
    //This code is use for get scrftoken ... end

    //This code is use for get user information / get user profile ... start
    const getProfile = async (csrfToken) => {
        let details = await getUserDetails();
        try {
            axios({
                method: 'get',
                headers: {
                    'X-CSRF-Token': csrfToken
                },
                url: API_URL + API_PATH.getMyProfileAPI + `${details.user_id}`,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        await setCookie('firstName', response.data.data.first_name);
                        await setCookie('organization', response.data.data.organization);
                        await setCookie('lastName', response.data.data.last_name);
                        await clearCookie('session');
                        history.push({
                            pathname: '/UsersDashboard',
                            state: { newLogin: true }
                        });
                    } else {
                        if (Cookies.get('email')) {
                            clearCookie('email');
                            clearCookie('payload');
                            clearCookie('idToken');
                            clearCookie('organization');
                            clearCookie('atexpiry');
                        }
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                    }
                    setLoader(false);
                })
                .catch(function (error) {
                    if (error.response) {
                        if (error.response.data.message) {
                            setErrMsgType('error')
                            setErrMsg(error.response.data.message.message);
                            setErrPopUp(true)
                        } else {
                            setErrMsgType('error')
                            setErrMsg('Something went wrong.');
                            setErrPopUp(true)
                        }
                    } else {
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                    }
                    if (Cookies.get('email')) {
                        clearCookie('email');
                        clearCookie('payload');
                        clearCookie('idToken');
                        clearCookie('organization');
                        clearCookie('atexpiry');
                    }
                    setLoader(false);
                })
        } catch (error) {
            console.error(error);
        }
    }
    //This code is use for get user information / get user profile ... end

    const ShowErrPopUP = () => {
        setErrPopUp(false)
    };

    return (
        <React.Fragment>
            <Header />
            <CssBaseline />
            <div className={classes.signMain}>
                <Container maxWidth="sm" className={classes.userFormContainer}>
                    <Typography component="div" style={{ backgroundColor: '#fff', minHeight: '360px', paddingBottom: '10px', position: 'relative', border: '1px solid #24618E', borderRadius: '5px', }}>
                        <div className={classes.formLogo}>
                            {/* <p><NavLink className={classes.closeIcon} to="/"><FontAwesomeIcon icon={faTimes} className={classes.btnIcon} /></NavLink></p> */}
                            <img src={require('../../assets/images/dataPointMainLogo.svg')} className={classes.formIcon}></img>
                        </div>
                        {errMsg ? <div className={classes.errMsgSignIn}><ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /></div> : null}
                        <form className={classes.rootForm} noValidate autoComplete="off" onSubmit={e => validateForm(e)}>
                            <h3>Please Update Password</h3>
                            <img src={require('../../assets/images/hrimg.svg')} style={{ marginBottom: '10px', width: '100%', height: '1px' }} />
                            <Grid container className={classes.rootBox} spacing={spacing}>
                                <Grid item xs={12}>
                                    <Grid container justify="center" spacing={spacing}>
                                        <Grid xs={12} item>
                                            <Paper className={classes.paper} >
                                                <ul>
                                                    <li>be at least 8 characters long</li>
                                                    <li>contain at least 1 number, 1 upper-case letter, and 1 lower-case letter</li>
                                                    <li>contain at least 1 special character</li>
                                                    <li>not contain your name or email address</li>
                                                </ul>
                                            </Paper>
                                        </Grid>
                                        <Grid xs={12} item>
                                            <Paper className={classes.paper} >
                                                <TextField id="new_password" data-testid="new_password" className={classes.formInput} placeholder="New Password *" type="password" variant="outlined" required onChange={handleChange('newPass')} data-testid='newPass' value={values.newPass} />
                                            </Paper>
                                        </Grid>
                                        <Grid xs={12} item>
                                            <Paper className={classes.paper} >
                                                <TextField id="confirm_new_password" data-testid="confirm_new_password" className={classes.formInput} placeholder="Confirm New Password *" type="password" variant="outlined" required onChange={handleChange('conNewPass')} data-testid='conNewPass' value={values.conNewPass} />
                                            </Paper>
                                        </Grid>
                                        <Grid xs={12} item>
                                            <Paper className={classes.paper} style={{ textAlign: 'center', display: 'inline-block' }} >
                                                <Button type="submit" variant="outlined" id="save_btn1" data-testid="save_pwd_btn" className={classes.signInBtn}>
                                                    {loader == true ?
                                                        <CircularProgress />
                                                        :
                                                        'Update'
                                                    } </Button>
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Typography>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default ChangeAdminPassword;
//End ChangeAdminPassword component code ....